export default __webpack_public_path__ + "static/merchant-acquiring-solution-c649c1fb5f685cb6740e5c580eeb2474.png";